// extracted by mini-css-extract-plugin
export default {"main-section__2":"Section2_main-section__2__zPrRb","main-section__2__image":"Section2_main-section__2__image__OO2xP","main-section__2__text":"Section2_main-section__2__text__xEMZ+"};